.grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: var(--space-5);
  padding: 0 var(--space-6) var(--space-7);
  background: #fff;
}
